"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVehicleTypeStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
const RadioOption_1 = __importDefault(require("../../components/Form/RadioGroup/RadioOption"));
const i18n_1 = require("../../common/i18n");
exports.useVehicleTypeStore = (0, pinia_1.defineStore)('vehicleTypeStore', {
    state: () => ({
        vehicleTypes: [],
        selectedVehicleType: null
    }),
    getters: {
        vehicleTypeOptions: (state) => {
            return state.vehicleTypes.map((vehicleType) => {
                return new Option_1.default(vehicleType['@id'], vehicleType.name, false);
            });
        },
        selectedVehicleTypeTyrePositions: (state) => {
            if (state.selectedVehicleType === null) {
                return [];
            }
            return state.selectedVehicleType.tyrePositions.map((tyrePosition) => {
                return new RadioOption_1.default(tyrePosition['@id'], `<img class="block" src="images/tyrePositions/${tyrePosition.image}">
            <div class="text-center text-sm">${(0, i18n_1.trans)(tyrePosition.name.toLowerCase().replace("/ /g", "_"), tyrePosition.name, 'tyre_positions')}</div>`, false);
            });
        }
    },
    actions: {
        getVehicleTypes(router, params = {}) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_vehicle_types_api', query: params }).href)
                    .then((response) => {
                    let vehicleTypes = [];
                    if (Array.isArray(response['hydra:member'])) {
                        response['hydra:member'].forEach(element => {
                            if (element['@type'] !== 'VehicleType') {
                                return;
                            }
                            vehicleTypes.push(element);
                        });
                    }
                    this.vehicleTypes = vehicleTypes;
                    resolve(response);
                })
                    .catch(error => {
                    reject(error);
                });
            });
        },
        reset() {
            this.selectedVehicleType = null;
            this.vehicleTypes = [];
        }
    },
});
